import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-dc-svg",
  "use": "icon-dc-svg-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" overflow=\"hidden\" id=\"icon-dc-svg\"><rect x=\"31\" y=\"16\" width=\"34\" height=\"14\" /><circle cx=\"18\" cy=\"75\" r=\"6\" /><circle cx=\"48\" cy=\"75\" r=\"6\" /><circle cx=\"78\" cy=\"75\" r=\"6\" /><path d=\"M54.5 48 50 43.5 50 34 46 34 46 43.5 41.5 48 16 48 16 66 20 66 20 52 41.5 52 46 56.5 46 66 50 66 50 56.5 54.5 52 76 52 76 66 80 66 80 48ZM48 55 43 50 48 45 53 50Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol